var module = angular.module('octopusApp.projects');

module.directive('featureEditor', function ($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      action: '=',
      step: '=',
      project: '=',
      enabledFeatures: '=',
      localNames: '='
    },
    templateUrl: 'areas/projects/views/feature_editor.html',
    link: function (scope, element) {
      scope.$watch('enabledFeatures', function() {
        var action = scope.action;
        var step = scope.step;
        if (!action || !step) {
          return;
        }

        var actionBody = $('.feature-list', element);
        actionBody.html('');

        if (!scope.enabledFeatures) {
          return;
        }
        var featureNames = scope.enabledFeatures.split(',');

        var allFeatures = pluginRegistry.getAllFeatures();

        _.each(allFeatures, function (feature) {
          var isEnabled = _.contains(featureNames, feature.featureName);
          if (!isEnabled) {
            return;
          }

          var viewTemplateUrl = feature.editTemplateUrl;

          var template = $templateCache.get(viewTemplateUrl);
          if (!template) {
            octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
            return;
          }

          if (feature.preLink) {
            feature.preLink(scope);
          }

          var child = $compile(template)(scope);
          if (feature.editLink) {
            feature.editLink(scope, child, action, step, scope.project);
          }

          actionBody.append(child);
        });

      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/feature_editor.js
// module id = 541
// module chunks = 1